import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function Header({ mobileMenuOpen, setMobileMenuOpen, handleScroll }) {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 w-full z-50 bg-white border-b border-slate-100 shadow-[0_1px_12px_rgba(0,0,0,0.04)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-18" style={{ height: "72px" }}>

          {/* Left: Logo Image */}
          <motion.div
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="flex items-center cursor-pointer"
            onClick={() => handleScroll("home")}
          >
            <img
              src="/logo.png"
              alt="Americar"
              className="h-10 w-auto object-contain"
              fetchPriority="high"
              decoding="sync"
            />
          </motion.div>

          {/* Center: Desktop Nav */}
          <nav className="hidden md:flex items-center space-x-8">
            {["How it Works", "Features", "For Businesses", "About Us"].map((label) => {
              const id = label.toLowerCase().replace(/ /g, "");
              return (
                <a
                  key={id}
                  href={`#${id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    handleScroll(id === "forbusinesses" ? "vendors" : id === "howitworks" ? "howitworks" : id);
                  }}
                  className="text-[13px] font-medium text-slate-600 hover:text-primary transition-colors relative py-1 group"
                >
                  {label}
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary transition-all duration-300 group-hover:w-full rounded-full" />
                </a>
              );
            })}
          </nav>

          {/* Right: Desktop Buttons */}
          <div className="hidden md:flex items-center space-x-5">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              className="text-[13px] font-medium text-slate-600 hover:text-primary transition-colors"
              onClick={() => navigate("/login")}
            >
              Sign In
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.03, boxShadow: "0 4px 15px rgba(0, 122, 255, 0.25)" }}
              whileTap={{ scale: 0.97 }}
              className="bg-primary hover:bg-blue-600 text-white px-5 py-2.5 text-[13px] rounded-xl font-semibold transition-all shadow-sm"
              onClick={() => navigate("/signup")}
            >
              Get Started Free
            </motion.button>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden flex items-center">
            <button
              className="p-2 text-slate-600 hover:text-primary transition-colors"
              onClick={() => setMobileMenuOpen((s) => !s)}
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-slate-100 py-4 absolute bg-white w-full left-0 px-4 shadow-lg">
            <div className="flex flex-col space-y-4">
              {["How it Works", "Features", "For Businesses", "About Us"].map((label) => {
                const id = label.toLowerCase().replace(/ /g, "");
                return (
                  <a
                    key={id}
                    href={`#${id}`}
                    onClick={(e) => {
                      e.preventDefault();
                      handleScroll(id === "forbusinesses" ? "vendors" : id === "howitworks" ? "howitworks" : id);
                      setMobileMenuOpen(false);
                    }}
                    className="block text-slate-600 font-medium text-sm hover:text-primary"
                  >
                    {label}
                  </a>
                );
              })}
              <div className="pt-4 border-t border-slate-100 flex flex-col space-y-3">
                <button
                  onClick={() => { navigate("/login"); setMobileMenuOpen(false); }}
                  className="w-full text-slate-600 py-2 font-medium border border-slate-200 rounded-xl text-sm"
                >
                  Sign In
                </button>
                <button
                  onClick={() => { navigate("/signup"); setMobileMenuOpen(false); }}
                  className="w-full bg-primary text-white py-3 rounded-xl font-semibold text-sm"
                >
                  Get Started Free
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
